module.exports = __webpack_public_path__ + "img/logo-admin-putih.b1cd9e1e.png";